export var SEARCH_ENTITY_TYPES = {
  ORDER: 1,
  TROUBLETICKET: 2,
  DEVICE: 3,
  ADDRESS: 4,
  TRANSACTION: 5,
  CASE: 6,
  INVOICE: 7
};